/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Button,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Col,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { postMethod } from "../../services/httpServices";
import { useToasts } from "react-toast-notifications";
import FullPageLoader from "components/FullPageLoader/fullpageloader";
import NoRecordFound from "components/NoRecordFound/NoRecordFound";
import { btnCss, iconCss } from "../../appConfig";
import { getSortCls, getAmt } from "services/util";
import moment from "moment";
import ReactPaginate from "react-paginate";

const sortIS = {
  sortDebitToPhone: 0,
  sortDebitToName: 0,
  sortCreditToPhone: 0,
  sortCreditToName: 0,
  sortAmount: 0,
  sortTransactionDate: 0,
  sortTransactionReference: 0,
  sortDescription: 0,
  sortSyncStatus: 0,
  sortCreatedBy: 0,
};

const BankMankSyncLog = () => {
  const [loading, setLoading] = React.useState(false);
  const [filteredList, setFilteredList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [pageSize] = React.useState(10);
  const [pageCount, setPageCount] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [totalRec, setTotalRec] = React.useState(0);
  const [sort, setSort] = React.useState(sortIS);
  const [refresh, setRefresh] = React.useState(false);
  const [isMounted, setIsMounted] = React.useState(false);

  const { addToast } = useToasts();

  React.useEffect(() => {
    if (!refresh && isMounted) {
      const delayDebounce = setTimeout(() => {
        if ((searchText && searchText.length >= 3) || searchText.length === 0) {
          if (currentPage !== 0) {
            setCurrentPage(0);
          } else {
            fetchBankManSyncLog();
          }
        }
      }, 500); // debounce delay in ms

      return () => clearTimeout(delayDebounce);
    }
  }, [searchText]);

  React.useEffect(() => {
    fetchBankManSyncLog();
  }, [currentPage]);

  React.useEffect(() => {
    if (!refresh && isMounted) {
      if (currentPage != 0) {
        setCurrentPage(0);
      } else {
        fetchBankManSyncLog();
      }
    }
  }, [sort]);

  React.useEffect(() => {
    if (refresh && isMounted) {
      setSearchText("");
      setSort(sortIS);
      if (currentPage == 0) {
        fetchBankManSyncLog();
      } else {
        setCurrentPage(0);
      }
    }
  }, [refresh]);

  /**======================== File Functions ==========================*/

  const notifyFailed = (text) => {
    if (!text) {
      text = "Error in saving";
    }
    addToast(text, {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const getSearch = (val) => {
    setSearchText(val);
  };

  const reloadList = () => {
    setSearchText("");
    setRefresh(true);
  };

  const sortHandle = (fieldValue, fieldName) => {
    let newValue = 0;
    if (fieldValue == "0") {
      newValue = "1";
    } else if (fieldValue == "1") {
      newValue = "2";
    } else if (fieldValue == "2") {
      newValue = "1";
    }
    setSort({ ...sortIS, [fieldName]: newValue });
  };

  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  /**======================== API Calls ==========================*/

  const fetchBankManSyncLog = async () => {
    let errorMsg = "";
    setLoading(true);

    let data = {
      PageNumber: Number(currentPage + 1),
      PerPage: pageSize,
    };

    if (searchText && searchText.length >= 3) {
      data["SearchText"] = searchText;
    }

    if (sort.sortDebitToPhone == "1") {
      data["SortingOn"] = "DebitToPhone";
      data["IsDescending"] = false;
    } else if (sort.sortDebitToPhone == "2") {
      data["SortingOn"] = "DebitToPhone";
      data["IsDescending"] = true;
    } else if (sort.sortDebitToName == "1") {
      data["SortingOn"] = "DebitToName";
      data["IsDescending"] = false;
    } else if (sort.sortDebitToName == "2") {
      data["SortingOn"] = "DebitToName";
      data["IsDescending"] = true;
    } else if (sort.sortCreditToPhone == "1") {
      data["SortingOn"] = "CreditToPhone";
      data["IsDescending"] = false;
    } else if (sort.sortCreditToPhone == "2") {
      data["SortingOn"] = "CreditToPhone";
      data["IsDescending"] = true;
    } else if (sort.sortCreditToName == "1") {
      data["SortingOn"] = "CreditToName";
      data["IsDescending"] = false;
    } else if (sort.sortCreditToName == "2") {
      data["SortingOn"] = "CreditToName";
      data["IsDescending"] = true;
    } else if (sort.sortAmount == "1") {
      data["SortingOn"] = "Amount";
      data["IsDescending"] = false;
    } else if (sort.sortAmount == "2") {
      data["SortingOn"] = "Amount";
      data["IsDescending"] = true;
    } else if (sort.sortTransactionDate == "1") {
      data["SortingOn"] = "TransactionDate";
      data["IsDescending"] = false;
    } else if (sort.sortTransactionDate == "2") {
      data["SortingOn"] = "TransactionDate";
      data["IsDescending"] = true;
    } else if (sort.sortTransactionReference == "1") {
      data["SortingOn"] = "TransactionReference";
      data["IsDescending"] = false;
    } else if (sort.sortTransactionReference == "2") {
      data["SortingOn"] = "TransactionReference";
      data["IsDescending"] = true;
    } else if (sort.sortDescription == "1") {
      data["SortingOn"] = "Description";
      data["IsDescending"] = false;
    } else if (sort.sortDescription == "2") {
      data["SortingOn"] = "Description";
      data["IsDescending"] = true;
    } else if (sort.sortSyncStatus == "1") {
      data["SortingOn"] = "SyncStatus";
      data["IsDescending"] = false;
    } else if (sort.sortSyncStatus == "2") {
      data["SortingOn"] = "SyncStatus";
      data["IsDescending"] = true;
    } else if (sort.sortCreatedBy == "1") {
      data["SortingOn"] = "CreatedBy";
      data["IsDescending"] = false;
    } else if (sort.sortCreatedBy == "2") {
      data["SortingOn"] = "CreatedBy";
      data["IsDescending"] = true;
    }

    postMethod("/api/Transactions/GetBankManSyncLog", data, "post")
      .then((res) => {
        setLoading(false);
        setRefresh(false);
        setIsMounted(true);
        if (res?.data) {
          if (res.data.responseCode === "200" && res.data.result) {
            // Success
            if (!res.data.result.list?.length) {
              res.data.result.list = [];
            }
            setFilteredList(res.data.result.list);
            let pc = Math.ceil(res.data.result.totalRecords / pageSize);
            setTotalRec(res.data.result.totalRecords);
            setPageCount(pc);
          } else if (res.data.responseCode === "400") {
            // Error
            errorMsg = res.data.responseMessage || "Error in fetching list";
            notifyFailed(errorMsg);
          } else {
            // Unknown Error
            errorMsg = "Unknown Error in fetching";
            notifyFailed(errorMsg);
          }
        } else {
          errorMsg = "Unknown Error";
          notifyFailed(errorMsg);
        }
      })
      .catch((err) => {
        setLoading(false);
        setRefresh(false);
        setIsMounted(true);
        notifyFailed("Internal Server Error");
      });
  };
  const notifySuccess = (text) => {
    if (!text) {
      text = "Save successfully";
    }
    addToast(text, {
      appearance: "success",
      autoDismiss: true,
    });
  };
  const retrySyncLog = async (id) => {
    setLoading(true);

    postMethod(`/api/Transactions/BankManSyncRetry?Id=${id}`, {}, "post")
      .then((res) => {
        setLoading(false);

        if (res?.data) {
          notifySuccess("Retry Successful!");
        }
      })
      .catch((err) => {
        notifyFailed("Internal Server Error");
      });
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                {/* <h3 className="mb-0">Card tables</h3> */}

                <Form
                  className="form-inline mr-3 d-md-flex ml-lg-auto"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <FormGroup className="mb-0 navbar-search ">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        className="search-cls"
                        placeholder="Search"
                        type="text"
                        value={searchText}
                        onChange={(e) => getSearch(e.target.value)}
                      />
                    </InputGroup>
                  </FormGroup>
                  &nbsp;&nbsp;
                  <Button
                    color="primary"
                    onClick={reloadList}
                    // size="sm"
                    className="my-4"
                    style={btnCss}
                    data-toggle="tooltip"
                    title="Refresh"
                  >
                    <i className="fas fa-redo fa-lg" style={iconCss}></i>
                  </Button>
                </Form>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(
                          sort.sortTransactionReference,
                          "sortTransactionReference"
                        )
                      }
                    >
                      Transaction Reference
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortTransactionReference)}
                          onClick={() =>
                            sortHandle(
                              sort.sortTransactionReference,
                              "sortTransactionReference"
                            )
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(sort.sortCreditToName, "sortCreditToName")
                      }
                    >
                      Credit To Name
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortCreditToName)}
                          onClick={() =>
                            sortHandle(
                              sort.sortCreditToName,
                              "sortCreditToName"
                            )
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(sort.sortCreditToPhone, "sortCreditToPhone")
                      }
                    >
                      Credit To Phone
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortCreditToPhone)}
                          onClick={() =>
                            sortHandle(
                              sort.sortCreditToPhone,
                              "sortCreditToPhone"
                            )
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(sort.sortDebitToName, "sortDebitToName")
                      }
                    >
                      Debit To Name
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortDebitToName)}
                          onClick={() =>
                            sortHandle(sort.sortDebitToName, "sortDebitToName")
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(sort.sortDebitToPhone, "sortDebitToPhone")
                      }
                    >
                      Debit To Phone
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortDebitToPhone)}
                          onClick={() =>
                            sortHandle(
                              sort.sortDebitToPhone,
                              "sortDebitToPhone"
                            )
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() => sortHandle(sort.sortAmount, "sortAmount")}
                    >
                      Amount
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortAmount)}
                          onClick={() =>
                            sortHandle(sort.sortAmount, "sortAmount")
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(sort.sortDescription, "sortDescription")
                      }
                    >
                      Description
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortDescription)}
                          onClick={() =>
                            sortHandle(sort.sortDescription, "sortDescription")
                          }
                        />
                      </button>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(sort.sortSyncStatus, "sortSyncStatus")
                      }
                    >
                      Sync Status
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortSyncStatus)}
                          onClick={() =>
                            sortHandle(sort.sortSyncStatus, "sortSyncStatus")
                          }
                        />
                      </button>
                    </th>

                    <th
                      scope="col"
                      onClick={() =>
                        sortHandle(
                          sort.sortTransactionDate,
                          "sortTransactionDate"
                        )
                      }
                    >
                      Transaction Date
                      <button style={btnCss}>
                        <i
                          className={getSortCls(sort.sortTransactionDate)}
                          onClick={() =>
                            sortHandle(
                              sort.sortTransactionDate,
                              "sortTransactionDate"
                            )
                          }
                        />
                      </button>
                    </th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.length > 0 &&
                    filteredList.map((mmo, i) => {
                      return (
                        <tr key={mmo.id}>
                          <td>{mmo.transactionReference}</td>
                          <td>{mmo.creditToName}</td>
                          <td>{mmo.creditToPhone}</td>
                          <td>{mmo.debitToName}</td>
                          <td>{mmo.debitToPhone}</td>

                          <td>{getAmt(mmo.amount)}</td>
                          <td>{mmo.description}</td>
                          <td className="text-center">
                            <i
                              className={`fas fa-circle ${
                                mmo.syncStatus ? "text-green" : "text-red"
                              }`}
                            />
                          </td>
                          <td>
                            {moment(mmo.transactionDate).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </td>
                          <td>
                            {!mmo?.syncStatus && (
                              <Button
                                onClick={() => retrySyncLog(mmo.id)}
                                style={{ ...btnCss, color: "#00923f" }}
                                disabled={loading}
                              >
                                Retry <i className="fas fa-sync-alt"></i>
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                {loading && <FullPageLoader label={"Fetching..."} />}
                {!loading && !filteredList.length && <NoRecordFound />}
              </Table>

              <CardFooter className="py-4">
                {filteredList.length > 0 && (
                  <Row>
                    <Col lg="6">
                      <div>
                        <small>
                          <strong>Total Records : {totalRec}</strong>
                        </small>
                      </div>
                    </Col>

                    <Col lg="6">
                      <nav aria-label="...">
                        <div className="float-right">
                          <ReactPaginate
                            previousLabel={"prev"}
                            nextLabel={"next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={handlePageClick}
                            containerClassName={"paginationV2"}
                            subContainerClassName={"pages paginationV2"}
                            activeClassName={"active"}
                            forcePage={currentPage}
                          />
                        </div>
                      </nav>
                    </Col>
                  </Row>
                )}
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default BankMankSyncLog;
